import React, { useCallback, useEffect, useRef, useState } from 'react';
import coverImg from '../../utils/cover-img.jpg';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import './order.css';
import api from '../../api/api';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import RateProductModal from '../rate-product/RateProductModal';
import axios from 'axios';
import RateProductStar from "../../utils/stars.svg";
import { LuStar } from "react-icons/lu";
import UpdateRatingModal from '../rate-product/UpdateRatingModal';
import { Modal } from 'react-bootstrap';
import { AiOutlineCloseCircle, AiOutlineQuestionCircle } from 'react-icons/ai';
import { ValidateNoInternet } from '../../utils/NoInternetValidator';
import { MdOutlineRateReview, MdSignalWifiConnectedNoInternet0 } from 'react-icons/md';
import DeliveryFeedbackModal from '../delivery-feedback/DeliveryFeedbackModal';
import OrderComplaintModal from '../order-complaints/OrderComplaintModal';
import { setHDFCOrderID } from '../../model/reducer/cartReducer';
import { useRazorpay } from 'react-razorpay';
import PaystackPop from '@paystack/inline-js';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import InjectCheckout from '../checkout/StripeModal';
import PaypalSVG from "../../utils/Paypal.svg";
import PayStackSVG from "../../utils/Paystack.svg";
import RazorPaySVG from "../../utils/Razorpay.svg";
import StripeSVG from "../../utils/Stripe.svg";
import MidtransSVG from "../../utils/Icons/Midtrans.svg";
import PhonePeSVG from "../../utils/Icons/Phonepe.svg";
import hdfc from '../../utils/Icons/ic_hdfc.svg';
import cashfree from '../../utils/ic_cashfree.svg';
import paytabs from '../../utils/Icons/ic_paytabs.svg';



const OrderDetails = React.memo(() => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const setting = useSelector(state => state.setting);
    const user = useSelector(state => state?.user?.user);
    const jwtToken = useSelector(state => state.user?.jwtToken);
    // console.log(user);

    const [orderData, setOrderData] = useState(null);
    const [orderStatus, setOrderStatus] = useState(t("recieved"));
    const [showPdtRatingModal, setShowPdtRatingModal] = useState(false);
    const [ratingProductId, setRatingProductId] = useState(0);
    const [editRatingId, setEditRatingId] = useState(0);
    const [showRatingEditModal, setShowRatingEditModal] = useState(false);
    const [isNetworkError, setIsNetworkError] = useState(false);
    // const [showReturnModal, setShowReturnModal] = useState(false);
    const [showReturnModal, setShowReturnModal] = useState([]);
    const [showCancelModal, setShowCancelModal] = useState([]);
    // Delivery Feedback Modal
    const [isFeedbackModalOpen, setIsFeedbackModalOpen] = useState(false);
    // Order Complaint Modal
    const [isComplaintModalOpen, setIsComplaintModalOpen] = useState(false);
    // Pay Now Modal
    const [showPayNowModal, setShowPayNowModal] = useState(false);
    const [paymentMethod, setPaymentMethod] = useState("");
    const [stripeTransId, setStripeTransId] = useState(null);
    const [stripeClientSecret, setStripeClientSecret] = useState(null);
    const [stripeModalShow, setStripeModalShow] = useState(false);
    const urlParams = useParams();
    
    const stripePromise = loadStripe(setting.payment_setting && setting.payment_setting.stripe_publishable_key);

    // useEffect(() => {
    // }, [])
    useEffect(() => {
        setShowReturnModal(Array(orderData?.items?.length).fill(false))
        setShowCancelModal(Array(orderData?.items?.length).fill(false))
        if (orderData?.active_status === "6") {
            setOrderStatus(t("delivered"));
        } else if (orderData?.active_status === "5") {
            setOrderStatus(t("out_for_delivery"));
        } else if (orderData?.active_status === "4") {
            setOrderStatus(t("shipped"));
        } else if (orderData?.active_status === "3") {
            setOrderStatus(t("processed"));
        }
        else if (orderData?.active_status === "7") {
            setOrderStatus(t("cancelled"));
        }
        else if (orderData?.active_status === "8") {
            setOrderStatus(t("returned"));
        }
    }, [orderData]);



    const placeHolderImage = (e) => {
        e.target.src = setting.setting?.web_logo;
    };
    const fetchOrderDetails = async () => {
        api.getOrders(jwtToken, null, null, null, urlParams?.id).then(result => result.json()).then((response) => {

            if (response.status) {
                setOrderData(response.data[0]);
            } else {
                toast.error(response.message);
            }

        }).catch(err => {
            console.log(err)
            const isNoInternet = ValidateNoInternet(err);
            if (isNoInternet) {
                setIsNetworkError(true);
            }
        });

    };


    useEffect(() => {
        fetchOrderDetails();
        // console.log(orderData, 'orderDaraaa')
    }, [editRatingId, showPdtRatingModal]);

    const returnRef = useRef(null);
    const cancelRef = useRef(null);

    const getInvoice = async (Oid) => {
        let postData = new FormData();
        postData.append('order_id', Oid);
        axios({
            url: `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_SUBURL}/invoice_download`,
            method: 'post',
            responseType: 'blob',
            /*responseType: 'application/pdf',*/
            data: postData,
            headers: {
                Authorization: `Bearer ${jwtToken}`
            }
        }).then(response => {
            var fileURL = window.URL.createObjectURL(new Blob([response.data]));
            var fileLink = document.createElement('a');
            fileLink.href = fileURL;
            fileLink.setAttribute('download', 'Invoice-No:' + Oid + '.pdf');
            document.body.appendChild(fileLink);
            fileLink.click();
        }).catch(error => {
            if (error.request.statusText) {
                toast.error(error.request.statusText);
            } else if (error.message) {
                toast.error(error.message);
            } else {
                toast.error("Something went wrong!");
            }
        });
    };
    const navigate = useNavigate();

    const handleUpdateStatus = async (item_id, status, return_reason, isReturn = false) => {
        await api.updateOrderStatus(jwtToken, orderData?.id, item_id, status, return_reason, isReturn)
            .then((result) => result.json())
            .then((response) => {
                if (response.status) {
                    fetchOrderDetails();
                    // response.data && setOrderData(response.data);
                    // console.log(response.data, "update_order_status");
                    toast.success(response.message);
                    setShowReturnModal(false);
                    setShowCancelModal(false)
                } else if (response.message == "This Order Item is already Returned!") {
                    fetchOrderDetails();
                    toast.error(response.message);
                } else {
                    toast.info(response.message);
                }
                setShowCancelModal(false)
                setShowReturnModal(false);
            }).catch((error) => {
                console.error(error);
            });
    };

    const convertToAMPM = (transactionDate) => {
        const dateTimeObj = new Date(transactionDate);
        const options = { hour: 'numeric', minute: 'numeric', second: 'numeric', hour12: true };
        const timeInAMPMFormat = dateTimeObj.toLocaleString('en-US', options);
        // console.log("updated date", timeInAMPMFormat)
        return timeInAMPMFormat;
    };

    const handlePmtMethodChange = (value) => {
        setPaymentMethod(value);
    };

    const initializeRazorpay = () => {
        return new Promise((resolve) => {
            const script = document.createElement("script");
            script.src = "https://checkout.razorpay.com/v1/checkout.js";

            script.onload = () => {
                resolve(true);
            };
            script.onerror = () => {
                resolve(false);
            };
            document.body.appendChild(script);
        });
    };

    const { Razorpay } = useRazorpay();

    const handleRazorpayPayment = useCallback(async (razorpay_transaction_id, amount, name, email, mobile, app_name) => {
        const res = await initializeRazorpay();
        if (!res) {
            console.error("RazorPay SDK Load Failed");
            return;
        }
        const key = setting.payment_setting && setting.payment_setting.razorpay_key;
        const convertedAmount = Math.floor(amount * 100);
        const options = {
            key: key,
            amount: convertedAmount,
            currency: "INR",
            name: name,
            description: app_name,
            image: setting.setting && setting.setting.web_settings.web_logo,
            order_id: razorpay_transaction_id,
            handler: async (res) => {
                if (res.razorpay_payment_id) {
                    await api.addTransaction(jwtToken, orderData?.id, razorpay_transaction_id, "Razorpay COD", "order", amount)
                        .then(response => response.json())
                        .then(result => {
                            if (result.status === 1) {
                                setShowPayNowModal(false);
                                toast.success(result.message);
                                fetchOrderDetails();
                            } else {
                                toast.error(result.message);
                            }
                        })
                        .catch(error => console.log(error));
                }
            },
            modal: {
                confirm_close: true,
                ondismiss: async (reason) => {
                    if (reason === undefined) {
                        setShowPayNowModal(false);
                        setPaymentMethod("");
                    }
                }
            },
            prefill: {
                name: name,
                email: email,
                contact: mobile,
            },
            notes: {
                address: "Razorpay Corporate ",
            },
            theme: {
                color: setting.setting && setting.setting.web_settings.color,
            },
        };
        const rzpay = new window.Razorpay(options);
        rzpay.on('payment.cancel', function (response) {
            toast.error(response);
            setShowPayNowModal(false);
        });
        rzpay.on('payment.failed', function (response) {
            toast.error(response);
        });
        rzpay.open();
    }, [Razorpay, jwtToken, orderData, setting]);

    const handlePayStackPayment = (email, amount, currency, support_email) => {
        let handler = PaystackPop.setup({
            key: setting.payment_setting && setting.payment_setting.paystack_public_key,
            email: email,
            amount: parseFloat(amount) * 100,
            currency: currency,
            ref: (new Date()).getTime().toString(),
            label: support_email,
            callback: async function (response) {
                await api.addTransaction(jwtToken, orderData?.id, response.reference, "Paystack", "order", amount)
                    .then(response => response.json())
                    .then(result => {
                        if (result.status === 1) {
                            toast.success(result.message);
                            setShowPayNowModal(false);
                            fetchOrderDetails();
                        } else {
                            toast.error(result.message);
                            setShowPayNowModal(false);
                        }
                    })
                    .catch(error => console.log(error));
            }
        });
        handler.openIframe();
    };

    const handlePaypalPayment = async (redirectUrl) => {
        window.open(redirectUrl, "_parent");
    };

    const handlePayNowSubmit = async (e) => {
        e.preventDefault();
        if (paymentMethod === "") {
            return toast.error(t("please_select_payment_method"));
        }
        try {
            let response, result;
            if (paymentMethod === "paypal" || paymentMethod === "stripe" || paymentMethod === "razorpay" || paymentMethod === "midtrans" || paymentMethod === "phonepe" || paymentMethod === "Cashfree COD" || paymentMethod === "paytabs" || paymentMethod === "HDFC COD") {
                response = await api.initiate_transaction(jwtToken, orderData?.id, paymentMethod, "order");
                result = await response.json();
            }
            if (paymentMethod === "Razorpay COD") {
                handleRazorpayPayment(result?.data?.transaction_id, orderData?.final_total, user?.name, user?.email, user?.mobile, setting.setting?.app_name);
            } else if (paymentMethod === "cashfree") {
                handlePayStackPayment(user?.email, orderData?.final_total, setting.payment_setting.paystack_currency_code, setting.setting.support_email);
            } else if (paymentMethod === "stripe") {
                setStripeTransId(result.data?.id);
                setStripeClientSecret(result.data?.client_secret);
                setStripeModalShow(true);
            } else if (paymentMethod === "paypal") {
                handlePaypalPayment(result?.data?.paypal_redirect_url);
            } else if (paymentMethod === "midtrans") {
                const windowWidth = 700;
                const windowHeight = 700;
                const windowLeft = window.screen.width / 2 - windowWidth / 2;
                const windowTop = window.screen.height / 2 - windowHeight / 2;
                const windowFeatures = `width=${windowWidth},height=${windowHeight},left=${windowLeft},top=${windowTop},resizable=yes,scrollbars=yes,status=yes`;
                const paymentWindow = window.open(result?.data?.snapUrl, "_blank", windowFeatures);
                const messageEventListener = async (event) => {
                    if (event.data === "Payment Done") {
                        paymentWindow.close();
                        toast.success(t("payment_successful"));
                        setShowPayNowModal(false);
                        fetchOrderDetails();
                        window.removeEventListener("message", messageEventListener);
                    }
                };
                window.addEventListener("message", messageEventListener);
                paymentWindow.onbeforeunload = () => {
                    window.removeEventListener("message", messageEventListener);
                };
            } else if (paymentMethod === "phonepe") {
                const windowWidth = 700;
                const windowHeight = 700;
                const windowLeft = window.screen.width / 2 - windowWidth / 2;
                const windowTop = window.screen.height / 2 - windowHeight / 2;
                const windowFeatures = `width=${windowWidth},height=${windowHeight},left=${windowLeft},top=${windowTop},resizable=yes,scrollbars=yes,status=yes`;
                const paymentWindow = window.open(result?.data?.redirectUrl, "_blank", windowFeatures);
                const messageEventListener = async (event) => {
                    if (event.data === "Payment Done") {
                        paymentWindow.close();
                        toast.success(t("payment_successful"));
                        setShowPayNowModal(false);
                        fetchOrderDetails();
                        window.removeEventListener("message", messageEventListener);
                    }
                };
                window.addEventListener("message", messageEventListener);
                paymentWindow.onbeforeunload = () => {
                    window.removeEventListener("message", messageEventListener);
                };
            } else if (paymentMethod === "Cashfree COD") {
                const paymentWindow = window.open(result?.data?.redirectUrl, "_blank");
                const messageEventListener = async (event) => {
                    if (event.data === "Payment Done") {
                        paymentWindow.close();
                        toast.success(t("payment_successful"));
                        setShowPayNowModal(false);
                        fetchOrderDetails();
                        window.removeEventListener("message", messageEventListener);
                    }
                };
                window.addEventListener("message", messageEventListener);
                paymentWindow.onbeforeunload = () => {
                    window.removeEventListener("message", messageEventListener);
                };
            } else if (paymentMethod === "paytabs") {
                const paymentWindow = window.open(result?.data?.redirectUrl, "_blank");
                const messageEventListener = async (event) => {
                    if (event.data === "Payment Done") {
                        paymentWindow.close();
                        toast.success(t("payment_successful"));
                        setShowPayNowModal(false);
                        fetchOrderDetails();
                        window.removeEventListener("message", messageEventListener);
                    }
                };
                window.addEventListener("message", messageEventListener);
                paymentWindow.onbeforeunload = () => {
                    window.removeEventListener("message", messageEventListener);
                };
            } else if (paymentMethod === "HDFC COD") {
                dispatch(setHDFCOrderID({ data: result?.data?.order_id }));
                window.open(result?.data?.redirect_url, "_parent");
            }
        } catch (err) {
            console.log(err.message);
        }
    };

    const getReturnStatusLabel = (status) => {
        switch (status) {
            case 1:
                return t("return_pending");
            case 2:
                return t("return_approved");
            case 3:
                return t("return_rejected");
            case 4:
                return t("return_delivery_boy_assigned");
            case 5:
                return t("return_out_for_pickup");
            case 6:
                return t("return_received_from_customer");
            case 7:
                return t("return_cancelled");
            case 8:
                return t("return_to_seller");
            default:
                return "";
        }
    }

    return (
        <>
            {!isNetworkError ?
                <section className="order-details-page">
                    <div className='cover'>
                        <img src={coverImg} onError={placeHolderImage} className='img-fluid' alt="cover"></img>
                        <div className='page-heading'>
                            <h3>{t("order_details")}</h3>
                            <p><strong onClick={() => navigate('/')}>{t("home")}</strong> / <span> <span onClick={() => navigate('/profile/orders')}>{t("order")}</span> / {orderData?.id}</span></p>
                        </div>
                    </div>

                    <div className="container">
                        <div className="row">
                            <div className="col-12 col-xl-9">
                                <div className="order-container">
                                    <div className="list-container">

                                        <div className="container-heading">
                                            <span>
                                                {t('items')}
                                            </span>
                                        </div>
                                        <div className="container-body">
                                            <div className="table-container">
                                                <table className="table">

                                                    <thead>
                                                        <th>{t('product')}</th>
                                                        <th>{t('price')}</th>
                                                        {orderData?.items?.some((item) => (Number(item?.active_status) == 6)) ? <th>{t('rating')}</th> : null}
                                                    </thead>
                                                    <tbody>
                                                        {orderData?.items?.map((item, index) => {
                                                            return (
                                                                <React.Fragment key={item?.id}>
                                                                    <tr className={Number(item?.active_status) > 6 ? 'disabled' : ''}>
                                                                        <td>
                                                                            <div className="product">

                                                                                <div className="image-container">
                                                                                    <img src={item.image_url} alt="" />
                                                                                </div>
                                                                                <div className="item-container">
                                                                                    <span className='item-name'>{item.name}</span>
                                                                                    <span className='item-quantity'> X {item.quantity}</span>
                                                                                    <span className='item-variant'>{` ${item.variant_name}`}</span>
                                                                                </div>
                                                                            </div>
                                                                        </td>
                                                                        <td>
                                                                            <div className="price-container">
                                                                                <span className="discounted-price">
                                                                                    {`${setting.setting?.currency} ${item.price}`}
                                                                                </span>
                                                                            </div>
                                                                            <div className="actions-container">
                                                                                {Number(item?.active_status) == 6 && item?.return_status == 1 && item?.return_requested === null ?
                                                                                    <span className="return">
                                                                                        <button onClick={() => setShowReturnModal(prevState => {
                                                                                            const newState = [...prevState];
                                                                                            newState[index] = true;
                                                                                            return newState;
                                                                                        })}>{t('return')}</button>
                                                                                    </span>
                                                                                    : null
                                                                                }

                                                                                {(Number(item?.active_status) <= 6) && (Number(item?.active_status) <= item?.till_status) && (item?.cancelable_status == 1) ?
                                                                                    <span className="cancel">
                                                                                        <button onClick={() => setShowCancelModal(prevState => {
                                                                                            const newState = [...prevState];
                                                                                            newState[index] = true;
                                                                                            return newState;
                                                                                        })}>{t('cancel')}</button>
                                                                                        {/* <button onClick={() => handleUpdateStatus(item?.id, 7)}>{t('cancel')}</button> */}
                                                                                    </span>
                                                                                    : null
                                                                                }
                                                                                {Number(item?.active_status) == 7 ?
                                                                                    <span className="cancel">
                                                                                        <button>{t('cancelled')}</button>
                                                                                    </span>
                                                                                    : null
                                                                                }

                                                                                {Number(item?.active_status) == 8 ?
                                                                                    <span className="return">
                                                                                        <button >{t('returned')}</button>
                                                                                    </span>
                                                                                    : null
                                                                                }
                                                                                {/* {Number(item?.return_requested === 1) ?
                                                                                    <span className="return">
                                                                                        <button>{t('return_requested')}</button>
                                                                                    </span>
                                                                                    : null
                                                                                }
                                                                                {Number(item?.return_requested === 3) ?
                                                                                    <span className="returned">
                                                                                        <button >{t('return_rejected')}</button>
                                                                                    </span>
                                                                                    : null
                                                                                } */}
                                                                                {Number(item?.return_track_status) ?
                                                                                    <span className="return">
                                                                                        <button>{getReturnStatusLabel(Number(item?.return_track_status))}</button>
                                                                                    </span>
                                                                                    : null}

                                                                            </div>

                                                                        </td>
                                                                        {(Number(item?.active_status) == 6) ?
                                                                            <td>
                                                                                <div className='rateProductText' >
                                                                                    {item.item_rating.find((rating) => rating.user.id === user.id) ?
                                                                                        <div className='pb-4' onClick={() => {
                                                                                            setRatingProductId(item.product_id);
                                                                                            setShowRatingEditModal(true);
                                                                                            setEditRatingId(item.item_rating.find((rating) => rating.user.id === user.id)?.id);
                                                                                        }}>
                                                                                            <span className='me-2' >
                                                                                                {t("you_rated")}
                                                                                            </span>
                                                                                            <span className="userRatedStarContainer">
                                                                                                <LuStar fill='white' stroke='white' />
                                                                                                {item?.item_rating?.find((rating) => rating?.user?.id === user?.id)?.rate}
                                                                                            </span>
                                                                                        </div>
                                                                                        :
                                                                                        <div className='rateProductText' onClick={() => {
                                                                                            setRatingProductId(item.product_id);
                                                                                            setShowPdtRatingModal(true);
                                                                                        }}>
                                                                                            <img className='me-2' src={RateProductStar} alt='rateProductStar' />
                                                                                            {t("review_and_rating")}
                                                                                        </div>
                                                                                    }
                                                                                </div>
                                                                            </td> : null}
                                                                    </tr>
                                                                    {showCancelModal[index] ?
                                                                        <Modal
                                                                            size='md'
                                                                            show={showCancelModal[index]}
                                                                            centered
                                                                            // onHide={() => setShowReturnModal(false)}
                                                                            onHide={() => setShowCancelModal(prevState => {
                                                                                const newState = [...prevState];
                                                                                newState[index] = false;
                                                                                return newState;
                                                                            })}
                                                                            backdrop="static"
                                                                        >
                                                                            <Modal.Header className='d-flex justify-content-between returnProductModalHeader'>
                                                                                <h5 className='title'>{t("cancel_order_item")}</h5>
                                                                                <AiOutlineCloseCircle className='cursorPointer' size={28} fill='black' onClick={() => setShowCancelModal(prevState => {
                                                                                    const newState = [...prevState];
                                                                                    newState[index] = false;
                                                                                    return newState;
                                                                                })} />
                                                                            </Modal.Header>
                                                                            <Modal.Body className='returnProductModalBody'>
                                                                                <form onSubmit={(e) => {
                                                                                    e.preventDefault();
                                                                                    // if (!returnRef.current.value.trim()) {
                                                                                    //     toast.error(t('please_type_return_reason'));
                                                                                    //     return; // Don't proceed further if the textarea is empty
                                                                                    // }
                                                                                    // handleUpdateStatus(item?.id, 8, returnRef.current.value);
                                                                                    handleUpdateStatus(item?.id, 7, cancelRef.current.value, false)
                                                                                }}>
                                                                                    <div className='d-flex flex-column justify-content-center'>
                                                                                        <label htmlFor='reasonTextArea' className='my-3 reasonLabel'>
                                                                                            {t("cancel_reason")}
                                                                                        </label>
                                                                                        <textarea
                                                                                            ref={cancelRef}
                                                                                            id="reasonTextArea"
                                                                                            rows={8}
                                                                                            name='reasonTextArea'
                                                                                            placeholder={t("write_cancel_reason")}
                                                                                            className='reasonTextArea my-4'
                                                                                            required
                                                                                        />
                                                                                    </div>
                                                                                    <div className='d-flex justify-content-end mt-4'>
                                                                                        <button type='submit' className='returnSubmitBtn'>
                                                                                            {t("cancel_order")}
                                                                                        </button>
                                                                                    </div>
                                                                                </form>
                                                                            </Modal.Body>
                                                                        </Modal>
                                                                        : null}
                                                                    {showReturnModal[index] ?
                                                                        <Modal
                                                                            size='md'
                                                                            show={showReturnModal[index]}
                                                                            centered
                                                                            // onHide={() => setShowReturnModal(false)}
                                                                            onHide={() => setShowReturnModal(prevState => {
                                                                                const newState = [...prevState];
                                                                                newState[index] = false;
                                                                                return newState;
                                                                            })}
                                                                            backdrop="static"
                                                                        >
                                                                            <Modal.Header className='d-flex justify-content-between returnProductModalHeader'>
                                                                                <h5 className='title'>{t("return_order_item")}</h5>
                                                                                <AiOutlineCloseCircle className='cursorPointer' size={28} fill='black' onClick={() => setShowReturnModal(prevState => {
                                                                                    const newState = [...prevState];
                                                                                    newState[index] = false;
                                                                                    return newState;
                                                                                })} />
                                                                            </Modal.Header>
                                                                            <Modal.Body className='returnProductModalBody'>
                                                                                <form onSubmit={(e) => {
                                                                                    e.preventDefault();
                                                                                    // if (!returnRef.current.value.trim()) {
                                                                                    //     toast.error(t('please_type_return_reason'));
                                                                                    //     return; // Don't proceed further if the textarea is empty
                                                                                    // }
                                                                                    handleUpdateStatus(item?.id, 8, returnRef.current.value, true);
                                                                                }}>
                                                                                    <div className='d-flex flex-column justify-content-center'>
                                                                                        <label htmlFor='reasonTextArea' className='my-3 reasonLabel'>
                                                                                            {t("return_reason")}
                                                                                        </label>
                                                                                        <textarea
                                                                                            ref={returnRef}
                                                                                            id="reasonTextArea"
                                                                                            rows={8}
                                                                                            name='reasonTextArea'
                                                                                            placeholder={t("write_return_reason")}
                                                                                            className='reasonTextArea my-4'
                                                                                            required
                                                                                        />
                                                                                    </div>
                                                                                    <div className='d-flex justify-content-end mt-4'>
                                                                                        <button type='submit' className='returnSubmitBtn'>
                                                                                            {t("request_a_return")}
                                                                                        </button>
                                                                                    </div>
                                                                                </form>
                                                                            </Modal.Body>
                                                                        </Modal>
                                                                        : null}
                                                                </React.Fragment>

                                                            );

                                                        })}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>


                                    </div>
                                </div>
                            </div>
                            <div className="col-12 col-xl-3">
                                <div className="order-info">
                                    <div className="order-status-container order-info-container">

                                        <div className="container-heading">
                                            <span>
                                                {t('order')}
                                            </span>
                                            <span className="order-id">
                                                #{orderData?.id}
                                            </span>
                                        </div>
                                        {orderData?.otp != 0 &&
                                            <div className=' d-flex justify-content-between status-otp-container'>
                                                <p>{t("otp")}</p>
                                                <p className='font-weight-bold display-6 otp-data'>{orderData?.otp}</p>
                                            </div>
                                        }
                                        <div className={`status-body ${orderData?.otp == 0 && 'mt-4'}`}>
                                            <div className="order-status-details">
                                                <div className="order-status">
                                                    {`${t('order')} ${orderStatus}`}
                                                </div>
                                                <div className="order-success">
                                                    {`${t('your_order_has_been')} ${orderStatus} ${t('successfully')}`}
                                                </div>
                                                <div className="status-date">
                                                    {orderData?.status?.length > 0 && new Date(orderData?.status.reverse()[0].reverse()[0]).toLocaleDateString()}
                                                    <p>{orderData?.status?.length > 0 && convertToAMPM(new Date(orderData?.status.reverse()[0].reverse()[0]))}</p>
                                                </div>
                                            </div>
                                            {/* {console.log(orderData)} */}
                                            {orderData?.active_status !== "6" && orderData?.is_cod_paid === 0 && orderData?.payment_method === "COD" ?
                                                (<div className='d-flex justify-content-center align-items-center is-cod-paid-container'
                                                    onClick={() => setShowPayNowModal(true)}
                                                >
                                                    <span className='pay-with-hdfc-bank'>{t("pay_now")}</span>
                                                </div>
                                                ) : null}
                                        </div>
                                    </div>
                                    {orderData?.order_note !== "" ? <div className='order-info-container order-note-container'>
                                        <div className='container-heading'>
                                            <span>
                                                {t("order_note_title")}
                                            </span>
                                        </div>
                                        <div className='order-note-details'>
                                            {orderData?.order_note.split('\r\n').map((line, index) => (
                                                <React.Fragment key={index}>
                                                    {line}
                                                    <br />
                                                </React.Fragment>
                                            ))}
                                        </div>
                                    </div> : null}
                                    <div className="order-info-container order-delivery-info">
                                        <div className="container-heading">
                                            <span>
                                                {t('delivery_information')}
                                            </span>
                                        </div>
                                        <div className="container-body">
                                            <div className="address-container">
                                                <span className='address-heading'>
                                                    {t('delivery_to')}
                                                </span>
                                                <span className='address-info'>
                                                    {orderData?.order_address}
                                                </span>
                                            </div>

                                            <div className="contact-container">
                                                <span>
                                                    {`${orderData?.country} - ${orderData?.mobile}`}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    {orderData?.active_status == 6 && orderData?.order_rating == 0 ? (
                                        <div className='order-info-container order-delivery-info'>
                                            <div className="container-heading">
                                                <span>
                                                    {t('delivery_feedback')}
                                                </span>
                                            </div>
                                            <div className="container-body mt-4">
                                                <div className="delivery-feedback-container d-flex justify-content-between align-items-center">
                                                    <span>{t("delivery_feedback_description")}</span>
                                                    <button className='bg-transparent border-0' onClick={() => setIsFeedbackModalOpen(true)}><MdOutlineRateReview size={24} /></button>
                                                </div>
                                            </div>
                                        </div>
                                    ) : null}
                                    {orderData?.active_status == 6 ? (
                                        <div className='order-info-container order-complaint-container'>
                                            <div className="container-body">
                                                <div className='w-100 d-flex justify-content-between align-items-center'>
                                                    <span>{t('complain_for_order_issue')}</span>
                                                    <button className='bg-transparent border-0 '
                                                        onClick={() => setIsComplaintModalOpen(true)}>
                                                        <AiOutlineQuestionCircle size={24} />
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    ) : null}

                                    <div className="order-info-container order-billing-container">
                                        <div className="container-heading">
                                            <span>
                                                {t('billing_details')}
                                            </span>
                                        </div>
                                        <div className="container-body">
                                            <div className="payment-info">
                                                <div>
                                                    <span>
                                                        {t('payment_method')}
                                                    </span>
                                                    <span>
                                                        {orderData?.payment_method}
                                                    </span>
                                                </div>
                                                <div>
                                                    <span>
                                                        {t('transaction_id')}
                                                    </span>
                                                    <span>
                                                        {orderData?.transaction_id}
                                                    </span>
                                                </div>
                                                <div>
                                                    <span>
                                                        {t('delivery_charge')}
                                                    </span>
                                                    <span>
                                                        {setting.setting?.currency}{orderData?.delivery_charge}
                                                    </span>
                                                </div>
                                                <div>
                                                    <span>
                                                        {t('sub_total')}
                                                    </span>
                                                    <span>
                                                        {setting.setting?.currency}{orderData?.total}
                                                    </span>
                                                </div>
                                                {orderData?.promo_discount ? <div>
                                                    <span>
                                                        {t('promo_code_discount')}
                                                    </span>
                                                    <span>
                                                        - {setting.setting?.currency}{orderData?.promo_discount}
                                                    </span>
                                                </div> : null}
                                                {orderData?.wallet_balance ? <div>
                                                    <span>
                                                        {t('wallet_balance_used')}
                                                    </span>
                                                    <span>
                                                        - {setting.setting?.currency}{orderData?.wallet_balance}
                                                    </span>
                                                </div> : null}
                                                {orderData?.discount ?
                                                    <div>
                                                        <span>
                                                            {t('discount')}
                                                        </span>
                                                        <span>
                                                            {setting.setting?.currency}{orderData?.discount}
                                                        </span>
                                                    </div>
                                                    : <></>}
                                            </div>
                                            <div className="order-total">

                                                <div>
                                                    <span>
                                                        {t('total')}
                                                    </span>
                                                    <span>
                                                        {setting?.setting?.currency}{orderData?.final_total}
                                                    </span>
                                                </div>
                                            </div>
                                            {orderData?.active_status === "6" ?
                                                <div className="button-container">
                                                    <button className="btn" onClick={() => {
                                                        getInvoice(orderData?.id);
                                                    }}>
                                                        {t('get_invoice')}
                                                    </button>
                                                </div>
                                                : <></>}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <RateProductModal product_id={ratingProductId} showPdtRatingModal={showPdtRatingModal} setShowPdtRatingModal={setShowPdtRatingModal} />
                    <UpdateRatingModal product_id={ratingProductId} showModal={showRatingEditModal} setShowModal={setShowRatingEditModal} ratingId={editRatingId} setRatingId={setEditRatingId} />
                    {isFeedbackModalOpen && (
                        <DeliveryFeedbackModal
                            isFeedbackModalOpen={isFeedbackModalOpen}
                            setIsFeedbackModalOpen={setIsFeedbackModalOpen}
                            orderId={orderData?.id}
                            delivery_boy_id={orderData?.delivery_boy_id}
                            fetchOrderDetails={fetchOrderDetails}
                        />
                    )}
                    {isComplaintModalOpen && (
                        <OrderComplaintModal
                            showModal={isComplaintModalOpen}
                            setShowModal={setIsComplaintModalOpen}
                            orderId={orderData?.id}
                        />
                    )}
                    {/* Pay Now Modal */}
                    <Modal
                        className='payNowModal'
                        size='md'
                        centered
                        show={showPayNowModal}
                        backdrop={"static"}
                    >
                        <Modal.Header className='d-flex justify-content-between'>
                            <div className='fw-bold modalHeading'>
                                {t("pay_now")}
                            </div>
                            <div className='closeModalBtn' onClick={() => {
                                setShowPayNowModal(false);
                                setPaymentMethod("");
                            }}><AiOutlineCloseCircle size={34} /></div>
                        </Modal.Header>
                        <Modal.Body>
                            <form onSubmit={handlePayNowSubmit}>
                                <div className='d-flex flex-column justify-content-start'>
                                    <div>
                                        <div className='mb-3'>
                                            <strong>{t("total_amount")}: </strong>
                                            {setting.setting?.currency}{orderData?.final_total}
                                        </div>
                                        <div>
                                            <div className='mb-4'>
                                                {t("choose_payment_method")}
                                            </div>
                                            <div className='d-flex flex-column gap-4'>
                                                {setting?.payment_setting?.paypal_payment_method === "1" ?
                                                    <div className='d-flex flex-row justify-content-between align-items-center paymentContainer'>
                                                        <div>
                                                            <img className='me-3' src={PaypalSVG} alt='paypalSVG' />
                                                            {t("paypal")}
                                                        </div>
                                                        <div>
                                                            <input type='radio' id='paymentRadioBtn' name='paymentRadioBtn' onChange={() => handlePmtMethodChange("paypal")} />
                                                        </div>
                                                    </div>
                                                    : null}
                                                {setting?.payment_setting?.razorpay_payment_method === "1" ?
                                                    <div className='d-flex flex-row justify-content-between align-items-center paymentContainer'>
                                                        <div>
                                                            <img className='me-3' src={RazorPaySVG} alt='razorPaySVG' />
                                                            {t("razorpay")}
                                                        </div>
                                                        <div>
                                                            <input type='radio' id='paymentRadioBtn' name='paymentRadioBtn' onChange={() => handlePmtMethodChange("Razorpay COD")} />
                                                        </div>
                                                    </div>
                                                    : null}
                                                {setting?.payment_setting?.cashfree_payment_method === "1" ?
                                                    <div className='d-flex flex-row justify-content-between align-items-center paymentContainer'>
                                                        <div className='d-flex align-items-center cashfree-div'>
                                                            <img className='me-3' src={cashfree} alt='cashfreeSVG' />
                                                            {t("cashfree")}
                                                        </div>
                                                        <div>
                                                            <input type='radio' id='paymentRadioBtn' name='paymentRadioBtn' onChange={() => handlePmtMethodChange("Cashfree COD")} />
                                                        </div>
                                                    </div>
                                                    : null}
                                                {setting?.payment_setting?.paystack_payment_method === "1" ?
                                                    <div className='d-flex flex-row justify-content-between align-items-center paymentContainer'>
                                                        <div>
                                                            <img className='me-3' src={PayStackSVG} alt='paystackSVG' />
                                                            {t("paystack")}
                                                        </div>
                                                        <div>
                                                            <input type='radio' id='paymentRadioBtn' name='paymentRadioBtn' onChange={() => handlePmtMethodChange("paystack")} />
                                                        </div>
                                                    </div>
                                                    : null}
                                                {setting?.payment_setting?.stripe_payment_method === "1" ?
                                                    <div className='d-flex flex-row justify-content-between align-items-center paymentContainer'>
                                                        <div>
                                                            <img className='me-3' src={StripeSVG} alt='stripeSVG' />
                                                            {t("stripe")}
                                                        </div>
                                                        <div>
                                                            <input type='radio' id='paymentRadioBtn' name='paymentRadioBtn' onChange={() => handlePmtMethodChange("stripe")} />
                                                        </div>
                                                    </div>
                                                    : null}
                                                {setting?.payment_setting?.midtrans_payment_method === "1" ?
                                                    <div className='d-flex flex-row justify-content-between align-items-center paymentContainer'>
                                                        <div>
                                                            <img className='     me-3' src={MidtransSVG} alt='MidtransSVG' />
                                                            {t("midtrans")}
                                                        </div>
                                                        <div>
                                                            <input type='radio' id='paymentRadioBtn' name='paymentRadioBtn' onChange={() => handlePmtMethodChange("midtrans")} />
                                                        </div>
                                                    </div>
                                                    : null}
                                                {setting?.payment_setting?.phonepay_payment_method === "1" ?
                                                    <div className='d-flex flex-row justify-content-between align-items-center paymentContainer'>
                                                        <div>
                                                            <img className='PhonePeSVG me-2' src={PhonePeSVG} alt='PhonePeSVG' />
                                                            {t("phonepe")}
                                                        </div>
                                                        <div>
                                                            <input type='radio' id='paymentRadioBtn' name='paymentRadioBtn' onChange={() => handlePmtMethodChange("phonepe")} />
                                                        </div>
                                                    </div>
                                                    : null}
                                                {setting?.payment_setting?.paytabs_payment_method === "1" ?
                                                    <div className='d-flex flex-row justify-content-between align-items-center paymentContainer'>
                                                        <div>
                                                            <img className='PhonePeSVG me-2' src={paytabs} alt='PaytabsSVG' />
                                                            {t("paytabs")}
                                                        </div>
                                                        <div>
                                                            <input type='radio' id='paymentRadioBtn' name='paymentRadioBtn' onChange={() => handlePmtMethodChange("paytabs")} />
                                                        </div>
                                                    </div>
                                                    : null}
                                                {setting?.payment_setting?.hdfc_payment_method === "1" ?
                                                    <div className='d-flex flex-row justify-content-between align-items-center paymentContainer'>
                                                        <div>
                                                            <img className='PhonePeSVG me-3' src={hdfc} alt='hdfcSVG' width={55} height={40} />
                                                            {t("hdfc")}
                                                        </div>
                                                        <div>
                                                            <input type='radio' id='paymentRadioBtn' name='paymentRadioBtn' onChange={() => handlePmtMethodChange("HDFC COD")} />
                                                        </div>
                                                    </div>
                                                    : null}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className='d-flex justify-content-end mt-4'>
                                    <button type='submit' className='payButton'>{t("proceed_to_pay")}</button>
                                </div>
                            </form>
                        </Modal.Body>
                    </Modal>
                    {/* Stripe Modal */}
                    <Modal id="stripeModal" size='lg' centered show={stripeModalShow}>
                        <Modal.Header onClick={() => setStripeModalShow(false)} className='header justify-content-between'>
                            <span style={{ color: '#33a36b', fontSize: '18px', fontWeight: 'bolder' }}>{process.env.REACT_APP_WEB_NAME} Payment</span>
                            <span style={{ cursor: 'pointer' }}>
                                <AiOutlineCloseCircle size={20} />
                            </span>
                        </Modal.Header>
                        <Modal.Body>
                            {stripeClientSecret === null || stripeTransId === null
                                ? <div className='d-flex justify-content-center align-items-center' style={{ minHeight: '200px' }}>Loading...</div>
                                :
                                <Elements stripe={stripePromise} client_secret={stripeClientSecret} transaction_id={stripeTransId} amount={orderData?.final_total}>
                                    <InjectCheckout
                                        setShow={setStripeModalShow}
                                        stripe={stripePromise}
                                        client_secret={stripeClientSecret}
                                        transaction_id={stripeTransId}
                                        amount={orderData?.final_total}
                                        order_id={orderData?.id}
                                    />
                                </Elements>
                            }
                        </Modal.Body>
                    </Modal>
                </section >
                :
                <div className='d-flex flex-column justify-content-center align-items-center noInternetContainer'>
                    <MdSignalWifiConnectedNoInternet0 />
                    <p>{t("no_internet_connection")}</p>
                </div>
            }
        </>
    );
});

export default OrderDetails;
